import { useFollowUpGrid, useFollowUpTable } from "../hooks/useFollowUp";
import { Card, CardContent, Grid, Typography } from "@mui/material";
import DataGrid from "components/DataGrid";
import { FormProvider } from "react-hook-form";
import ListIcon from "@mui/icons-material/List";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import "../css/index.css";
import FilterReport from "./FilterReport";

const ProgressReport = () => {
  const { form, dataRow, onGetData, onClear, isLoading, objTask, objInProgress, objCompleted, nYear } = useFollowUpTable();
  const { dataColumn } = useFollowUpGrid();
  return (
    <FormProvider {...form}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid item xs={12} className="Header-grid-form">
            <Typography
              className="price-blue"
              sx={{ position: "absolute", right: "4%" }}
            >
              ปี {nYear}
            </Typography>
            <Grid container spacing={1}>
              <Grid
                item
                xs={7}
                sx={{ display: "flex", alignItems: "center" }}
              >
                <Grid container spacing={1}>
                  <Grid item xs={4}>
                    <Card sx={{ backgroundColor: "#d1e9ff", width: "90%" }}>
                      <CardContent>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              padding: "1rem",
                              display: "flex",
                              flexDirection:
                                "column",
                              alignItems:
                                "center",
                              justifyContent:
                                "center",
                              backgroundColor: "#fff",
                              borderRadius: "50%"
                            }}
                          >
                            <ListIcon
                              className="price-blue"
                              sx={{
                                fontSize:
                                  "3rem",
                              }}
                            />
                          </div>

                          <div className="description">
                            <p className="title">
                              <strong>
                                {objTask?.sName}
                              </strong>
                            </p>
                            <p className="price">
                              {objTask?.nValue}
                            </p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card sx={{ backgroundColor: "#ffdec1", width: "90%" }}>
                      <CardContent>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              padding: "1rem",
                              display: "flex",
                              flexDirection:
                                "column",
                              alignItems:
                                "center",
                              justifyContent:
                                "center",
                              backgroundColor: "#fff",
                              borderRadius: "50%"
                            }}
                          >
                            <DonutSmallIcon
                              className="price-orange"
                              sx={{
                                fontSize:
                                  "3rem",
                              }}
                            />
                          </div>

                          <div className="description">
                            <p className="title">
                              <strong>
                                {objInProgress?.sName}
                              </strong>
                            </p>
                            <p className="price">
                              {objInProgress?.nValue}
                            </p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                  <Grid item xs={4}>
                    <Card sx={{ backgroundColor: "#dbf9e4", width: "90%" }}>
                      <CardContent>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              padding: "1rem",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#fff",
                              borderRadius: "50%"
                            }}
                          >
                            <EventAvailableIcon
                              className="price-green"
                              sx={{ fontSize: "3rem" }}
                            />
                          </div>

                          <div className="description">
                            <p className="title">
                              <strong>
                                {objCompleted?.sName}
                              </strong>
                            </p>
                            <p className="price">
                              {objCompleted?.nValue}
                            </p>
                          </div>
                        </div>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={5}>
                <Grid container spacing={1}>
                  <Grid item xs={12}>
                    <Typography
                      sx={{
                        fontSize: "1.25rem",
                        fontWeight: 500,
                        color: "rgb(52, 71, 103)",
                        textAlign: "center",
                      }}
                    >
                      ปริมาณกิจกรรมทั้งหมด
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <div
                      id="chartdiv"
                      style={{
                        width: "100%",
                        height: "200px",
                      }}
                    ></div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <FilterReport
            onSearch={() => onGetData(dataRow)}
            onClear={() => onClear()}
            onPreview={() => { }}
          />
        </Grid>
        <Grid item xs={12}>
          <DataGrid
            sTableID="tableReport"
            columns={dataColumn}
            rows={dataRow}
            modeFilter={0}
            isLoading={isLoading}
            onLoadData={(e) => onGetData(e)}
            isShowCheckBox={false}
            onDelete={() => { }}
            isHiddenToolHead
          />
        </Grid>
      </Grid>
    </FormProvider>
  );
};

export default ProgressReport;
